export const plan_selectPlan = (state) => state.plan.plan
export const plan_selectPlanIsLoading = (state) => state.plan.planIsLoading
export const plan_selectCalculationError = (state) => state.plan.calculationError